import { FIELD_TYPES } from "constants/template-field-type";
import AssetFieldsConfig from "components/core/asset/fields-config.js";
import fullParagraphFieldsConfig from "segments/desktop/core-components/full-paragraph/fields-config.js";
import LogosTitleFieldsConfig from "segments/desktop/logos/components/logos-title/fields-config";
import LogosFieldsConfig from "segments/desktop/core-components/logos/fields-config";
import ThemeConfig from "segments/core-configs/theme-config";

export default {
  type: FIELD_TYPES.NESTED,
  label: "Video Background",
  fields: {
    ...ThemeConfig,
    fullParagraphConfig: {
      type: FIELD_TYPES.NESTED,
      label: "Full Paragrapph",
      fields: {
        ...fullParagraphFieldsConfig
      }
    },
    assetConfig: {
      type: FIELD_TYPES.NESTED,
      label: "Asset",
      fields: {
        ...AssetFieldsConfig
      }
    },
    addDarkOverlay: {
      type: FIELD_TYPES.BOOLEAN,
      label: "Add Dark Overlay On Video"
    },
    hideBlackBars: {
      type: FIELD_TYPES.BOOLEAN,
      label: "Hide Black Bars"
    },
    logosProps: {
      type: FIELD_TYPES.CONDITIONAL_NESTED,
      label: "Add logos",
      conditionalKeyName: "useLogos",
      options: [
        {
          text: "Yes",
          fieldsConfig: {
            ...LogosTitleFieldsConfig,
            logos: {
              type: FIELD_TYPES.NESTED,
              label: "Logos",
              fields: LogosFieldsConfig
            }
          }
        }
      ]
    }
  }
};
